import { defineStore } from 'pinia'

/**
 * Global store — shared, cross-page state that doesn't fit any single
 * feature composable.
 *
 * Currently:
 *   - `_navItems`: the resolved vertical-nav tree. Rebuilt by the
 *     layout's `computed(getNavigation)` + `watchEffect` whenever any
 *     of its reactive inputs change (auth role, unread totals from
 *     `useLatestUpdates`, etc), so badge counts stay live without a
 *     per-item update API. If you need to nudge a specific item, do
 *     it by making `getNavigation` read your data and the watchEffect
 *     will pick it up.
 */
export const useGlobalStore = defineStore('globalStore', {
  id: 'globalStore',
  state: () => ({
    _navItems: [],
  }),
  getters: {
    getNavItems(state) {
      return state._navItems
    },
  },
  actions: {
    async setNavItems(items) {
      this._navItems = items.map(i => ({ ...i }))
    },
  },
})
